import  { FullScreenViewer } from 'iv-viewer';

export default FullScreenViewer;
